/**
 * Icon — renders a Lucide icon by name
 */
import {
  // Navigation
  Home, PawPrint, ClipboardList, MessageCircle, Settings,
  Bell, BellOff, LayoutDashboard, Users, Mail,
  // Notifications
  ClipboardCheck, BookOpen, Target, SkipForward,
  Dumbbell, Trophy, BookMarked, GraduationCap,
  // UI
  ArrowLeft, ArrowRight, ChevronLeft, ChevronRight, ChevronDown,
  Star, StarOff, Lock, Pencil, X, Check, Circle,
  GripVertical, Plus, RotateCcw, Clock, TrendingUp, Send,
  Camera, Trash2, Moon, Sun, Calendar, CalendarCheck, CalendarPlus, Palette, User, LogOut,
  Sprout, Ear, Eye, Zap, Award, Medal, Lightbulb, Sparkles, Puzzle, Shapes,
  HelpCircle,
  // External
  Globe,
  // Species
  Dog, Cat,
  // Commerce
  ShoppingCart, CircleCheck, PartyPopper, Crown, CreditCard, LoaderCircle,
  // Beta
  FlaskConical,
  // Misc
  Phone, Copy, LifeBuoy, Bug, Paperclip, Search,
  // Editor
  Bold, Heading, List, Link, Image, Video, ArrowUp, ArrowDown,
} from 'lucide-react';

const iconMap = {
  // Navigation
  Home, PawPrint, ClipboardList, MessageCircle, Settings,
  Bell, BellOff, LayoutDashboard, Users, Mail,
  // Notifications
  ClipboardCheck, BookOpen, Target, SkipForward,
  Dumbbell, Trophy, BookMarked, GraduationCap,
  // UI
  ArrowLeft, ArrowRight, ChevronLeft, ChevronRight, ChevronDown,
  Star, StarOff, Lock, Pencil, X, Check, Circle,
  GripVertical, Plus, RotateCcw, Clock, TrendingUp, Send,
  Camera, Trash2, Moon, Sun, Calendar, CalendarCheck, CalendarPlus, Palette, User, LogOut,
  Sprout, Ear, Eye, Zap, Award, Medal, Lightbulb, Sparkles, Puzzle, Shapes,
  HelpCircle,
  // External
  Globe,
  // Species
  Dog, Cat,
  // Commerce
  ShoppingCart, CircleCheck, PartyPopper, Crown, CreditCard, LoaderCircle,
  // Beta
  FlaskConical,
  // Misc
  Phone, Copy, LifeBuoy, Bug, Paperclip, Search,
  // Editor
  Bold, Heading, List, Link, Image, Video, ArrowUp, ArrowDown,
};

const Icon = ({ name, size = 20, className = '', ...props }) => {
  const IconComponent = iconMap[name];
  if (!IconComponent) return <span className={className}>{name}</span>;
  return <IconComponent size={size} className={className} {...props} />;
};

export default Icon;
